module.exports = __webpack_public_path__ + "static/img/14-北京市第十中学1.510063e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/14-北京市第十中学1.png
// module id = 3M91
// module chunks = 0